import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class AuthenticatedSlrLoanVerificationController extends Controller {
  /** `documents` when a documents surface opened the page; anything else returns to the SLR dashboard. */
  @tracked from = '';

  queryParams = [{ from: { type: 'string' as const } }];
}
